import { createAction } from '@reduxjs/toolkit'

import type { TGetTagOptionsResponse } from '@homepal/api-contract'

// tryGetAllTagOptions
export const getAllSuccess = createAction<TGetTagOptionsResponse>(
  'get_all_tag_options_success'
)
